import React, { useState, useEffect } from 'react';
import Card from '../../../components/common/Card';
import logo1 from "../../../assets/dashboard/dot.png"
import logo2 from "../../../assets/dashboard/soldproducts.png"


// import './CourseTable.css';
// import './policyManagement.css';
import { toast } from 'react-toastify';
// import CourseTable from './CourseTable';
// import CourseDetails from './CourseDetails';
import { assignStaff, deleteCourse, deleteMyPolicy, getAllCourses, getAllSalesByTrainer, getAllStaff, getLeaderboardData, getMyPolicies } from '../../../services/Trainer/trainer';
import SalesTable from './SalesTable';
import { acceptPolicy, declinePolicy, getAllPolicies, getAllSalesByAdmin } from '../../../services/Admin/admin';
import LeaderboardCard from './LeaderboardCard';


const StaffLeaderboars = () => {

  const [filter, setFilter] = useState('weekly');
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [addedCourse, setAddedCourse] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);

  const [courseToDelete, setCourseToDelete] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [courseToAssign, setCourseToAssign] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [allCoursesData, setAllCoursesData] = useState()
  const [allCourseLoading, setAllCourseLoading] = useState(false)
  const [assignStaffLoading, setAssignStaffLoading] = useState(false)
  const [searchedCourses, setSearchedCourses] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [cachedPages, setCachedPages] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);


  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    setIsSearching(true);
    console.log("searchTermsearchTerm", searchTerm)
    fetchCourseData(1, searchTerm);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchedCourses([]);
    setIsSearching(false);
    fetchCourseData(1);
  };

  const [allStaffData, setAllStaffData] = useState(null);

  // const fetchData = async () => {
  //   const data = await getAllStaff(); 
  //   if (data) {
  //     console.log("Staff data >>>", data);
  //     setAllStaffData(data.staffs);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const fetchCourseData = async () => {
  //   setAllCourseLoading(true)
  //    let data = await getAllCourses();
  //    if(data){
  //     console.log("data>><<<>",data)
  //     setAllCoursesData(data?.data)
  //    }
  //   setAllCourseLoading(false)

  // }

  const handleChangeFilter = (value) => {
    setFilter(value)
    fetchCourseData(1, value)
  }

  const fetchCourseData = async (page = 1, filter = '') => {
    setAllCourseLoading(true);

    // Check cache if not filtering
    // if (!filter && cachedPages[page]) {
    //   setAllCoursesData(cachedPages[page]);
    //   setCurrentPage(page);
    //   setAllCourseLoading(false);
    //   return;
    // }

    try {
      const data = await getLeaderboardData({ page, filter });
      if (data?.data) {
        setAllCoursesData(data.data);
        setCurrentPage(page);
        setTotalPages(data.totalPages || 1);

        // Cache only unfiltered data
        if (!filter) {
          setCachedPages(prev => ({
            ...prev,
            [page]: data.data
          }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
      setAllCourseLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseData(1,filter)
  }, [])


  useEffect(() => {
    // Check localStorage for any new courses
    // const storedCourses = localStorage.getItem('courses');
    // if (storedCourses) {
    //   setCourses(JSON.parse(storedCourses));
    // }

    // Check if we have a newly added course to show details for
    // const newAddedCourse = localStorage.getItem('addedCourse');
    // if (newAddedCourse) {
    //   setAddedCourse(JSON.parse(newAddedCourse));
    //   setIsDetailsModalOpen(true);
    //   // Clear the stored course after showing it
    //   localStorage.removeItem('addedCourse');
    // }
  }, []);



  const handleDeclineClick = (id) => {
    setCourseToDelete(id);
    setShowDeleteModal(true);
  };

  const handleAcceptClick = (id) => {
    setCourseToDelete(id);
    setShowAcceptModal(true);
  };

  const handleConfirmDecline = async () => {
    setLoadingDelete(true)
    const response = await declinePolicy(courseToDelete)
    console.log("resoponse>>", response)
    if (response?.success) {
      const updatedCourses = allCoursesData.map(course =>
        course._id === courseToDelete
          ? { ...course, isApproved: false }
          : course
      );
      setAllCoursesData(updatedCourses);
      toast.success(response?.message)
    }
    setLoadingDelete(false)

    setShowDeleteModal(false);
    // toast.success("Course deleted successfully!");
  };

  const handleConfirmAccept = async () => {
    setLoadingAccept(true)
    const response = await acceptPolicy(courseToDelete)
    console.log("resoponse>>", response)

    if (response?.success) {
      const updatedCourses = allCoursesData.map(course =>
        course._id === courseToDelete
          ? { ...course, isApproved: true }
          : course
      );
      setAllCoursesData(updatedCourses);
      toast.success(response?.message)
    }
    setLoadingAccept(false)
    setShowAcceptModal(false);
    // toast.success("Course deleted successfully!");
  };

  const handleAssignClick = (id) => {
    setCourseToAssign(id);
    setShowAssignModal(true);
    setSelectedStaff([]);
  };

  const handleStaffSelection = (staffId) => {
    if (selectedStaff.includes(staffId)) {
      setSelectedStaff(selectedStaff.filter(id => id !== staffId));
    } else {
      setSelectedStaff([...selectedStaff, staffId]);
    }
  };

  const handleAssignSubmit = async () => {
    console.log(`Assigning staff `, selectedStaff);
    setAssignStaffLoading(true)
    const data = {
      courseId: courseToAssign,
      staffIds: selectedStaff
    }

    const response = await assignStaff(data)
    console.log("response>>>>>", response)
    if (response.success) {
      toast.success(response.message)
    }
    else {
      toast.error(response.message)
    }
    setAssignStaffLoading(false)
    setShowAssignModal(false);
  };

  return (
    <div className="container mb-4">
       <h2 className='my-5'>Leaderboard</h2>
       {
        allCourseLoading ?

          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <>

      {
        allCoursesData && 
      <LeaderboardCard data={allCoursesData} />

      }
      <div className="flex space-x-4 mb-6" style={{ display: 'flex', gap: '10px', padding: '20px' }}>
        <button
          onClick={() => handleChangeFilter('weekly')}
          className={`px-6 py-3 rounded-xl shadow-md transition dashboard-btn
          ${filter === 'weekly'
              ? 'bg-[#f1eff4] text-gray-700'
              : 'bg-white text-black'
            }`}
        >
          Weekly
        </button>

        <button
          onClick={() => handleChangeFilter('monthly')}
          className={`px-6 py-3 rounded-xl shadow-md transition dashboard-btn
        ${filter === 'monthly'
              ? 'bg-[#f1eff4] text-gray-700'
              : 'bg-white text-black'
            }`}
        >
          Monthly
        </button>

        <button
          onClick={() => handleChangeFilter('yearly')}
          className={`px-6 py-3 rounded-xl shadow-md transition dashboard-btn
        ${filter === 'yearly'
              ? 'bg-[#f1eff4] text-gray-700'
              : 'bg-white text-black'
            }`}
        >
          Yearly
        </button>

      </div>
            <SalesTable
              courses={allCoursesData}
              setCourses={setAllCoursesData}
              onDeclinePolicy={handleDeclineClick}
              onAssignStaff={handleAssignClick}
              onAccept={handleAcceptClick}
            />


            {/* <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination">
               
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage - 1, filter)}
                    disabled={currentPage === 1}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

               
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchCourseData(page, filter)}
                    >
                      {page}
                    </button>
                  </li>
                ))}

                
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage + 1, filter)}
                    disabled={currentPage === totalPages}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav> */}
          </>
      }

    </div>
  );
};

export default StaffLeaderboars;